import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { getCasinoCategories } from '../../store/actions/casino.actions';
import CasinoSearch from './CasinoSearch';
import Util from '../../helper/Util';
import { gameNames } from '../../config';
import { useParams } from 'react-router-dom';
import { Translate } from '../../localization';
let timer = 0;

const settings = {
    dots: false,
    infinite: true,
    slidesToScroll: 2,
    margin: 30,
    variableWidth: true,
    nextArrow: <KeyboardArrowRightIcon />,
    prevArrow: <KeyboardArrowLeftIcon />,
};
const myStyles = {
    fontSize: '18px',
    fontWeight: 'bold',
};

const Categories = () => {
    const dispatch = useDispatch();
    const { pathname } = useLocation();
    const { category } = useParams()
    const [langCode, setLangCode] = useState(Translate.getLanguage())
    useEffect(() => {
        setLangCode(Translate.getLanguage())
    }, [])
    const { casinoCategories } = useSelector(state => state.casino);
    useEffect(() => {
        dispatch(getCasinoCategories());
    }, []);

    useEffect(() => {
        document.title = `${category}  Casino Games - JackpotCT`;
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute(
                'content',
                `Experience thrilling ${category} games at JackpotCT
        Casino. Join us today and experience the ultimate ${category} gaming adventure.`
            );
        }

    }, []);

    return (
        <div className="casino-categories mt-2">
            <div className='casino-categories-nav'>
                {casinoCategories.length > 0 && <Slider {...settings}>
                    <NavLink
                        // to='/d/casino'
                        to={`/${langCode}/d/casino`}
                        key='lobby'
                        isActive={() => [`/${langCode}/d/casino`].includes(pathname)} >
                        <img className='casino-category-img mr-2' src={`/img/SVG/${'All'}.png`} alt={`${Translate.lobby}`} />
                        <p>
                            {Translate.lobby}
                        </p>
                    </NavLink>
                    <NavLink to={`/${langCode}/d/casino/special-category/new`} key='Providers'>
                        <img className='casino-category-img mr-2' src={`/img/SVG/${'new'}.svg`} alt={`${Translate.new}`} />
                        <p>
                            {Translate.new}
                        </p>
                    </NavLink>
                    <NavLink to={`/${langCode}/d/casino/special-category/most_popular`} key='Providers'>
                        <img className='casino-category-img mr-2' src={`/img/SVG/${'most_popular'}.svg`} alt={`${Translate.hotGames}`} />
                        <p>
                            {Translate.hotGames}
                        </p>
                    </NavLink>

                    <NavLink to={`/${langCode}/d/casino/providers`} key='Providers'>
                        <img className='casino-category-img mr-2' src={`/img/SVG/${'PROVIDERS'}.svg`} alt={`${Translate.providers}`} />
                        <p>
                        {Translate.providers}    
                        </p>
                    </NavLink>
                    {casinoCategories && casinoCategories.map((category, i) => {
                        return (
                            <NavLink to={`/${langCode}/d/casino/categories/${category}`} key={category}>
                                <img className='casino-category-img mr-2' src={`/img/SVG/${category}.svg`} alt={`${Translate.tabNames[gameNames[Util.textCapitalize(category)]] || Translate.tabNames[Util.textCapitalize(category).replaceAll('_', ' ')]}`} />
                                <p>
                                    {Translate.tabNames[gameNames[Util.textCapitalize(category)]] || Translate.tabNames[Util.textCapitalize(category).replaceAll('_', ' ')]}
                                </p>
                            </NavLink>
                        );
                    })}
                </Slider>}
                <p>{category}</p>
            </div>
            <div className="casino-search-mob">
                <CasinoSearch />
            </div>
        </div >
    );
};

Categories.propTypes = {
    activeCategory: PropTypes.string,
    getCasinoGames: PropTypes.func,
    setCasinoActiveCategory: PropTypes.func,
    setSearchStarted: PropTypes.func,
    casinoCategories: PropTypes.object,
};

export default Categories;
